import { HttpClient } from '../services';
// import { API, Env } from '../../constants/settings';
import { ApiResponse } from '../data-source-handler';
import { errorHandlerCallback } from '../services/httpinvoker';

class DocsHandlerClass {
    GetAllDocs(link: string, callback: ApiResponse<string[]>) {
        HttpClient.Get('Get all docs', `${link}/helpfiles/list`, callback);
    }

    GetDocByName(link: string, docName: string, callback: ApiResponse<string>, errorCallback?: errorHandlerCallback) {
        HttpClient.Get('Get doc by name', `${link}/helpfiles/read?fileName=${docName}`, callback, errorCallback);
    }
}

const DocsHandler = new DocsHandlerClass();

export { DocsHandler };